<div class="row">
  <form [formGroup]="form">
  <div class="col-12 form-group">
      <label>{{ 'user.email' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['email']"></app-input-with-error>
    </div>
    <div class="col-12 form-group">
      <label>{{ 'user.given_name' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['given_name']"></app-input-with-error>
    </div>
    <div class="col-12 form-group">
      <label>{{ 'user.family_name' | translate }}</label>
      <app-input-with-error [control]="this.form.controls['family_name']"></app-input-with-error>
    </div>
    @if (assignableRoles.length > 1) {
      <div class="col-12 form-group">
        <label>{{ 'user.roles' | translate }}</label>
        <p-multiselect
          [options]="assignableRoles"
          formControlName="roles"
          optionValue="value"
          optionLabel="label"
          [showToggleAll]="false"
          [display]="'chip'"
          class="w-100">
        </p-multiselect>
      </div>
    }
  </form>
</div>
<app-error [error]="error"></app-error>
